import RefrigeratorBannerImage from "@/assets/images/category-banner.webp";
import refrigeratorTypeImage01 from "@/assets/images/static/categoryType/Refrigerators/refrigerators01.webp";
import refrigeratorTypeImage02 from "@/assets/images/static/categoryType/Refrigerators/refrigerators02.webp";
import refrigeratorTypeImage03 from "@/assets/images/static/categoryType/Refrigerators/refrigerators03.webp";
import refrigeratorTypeImage04 from "@/assets/images/static/categoryType/Refrigerators/refrigerators04.webp";
import refrigeratorTypeImage05 from "@/assets/images/static/categoryType/Refrigerators/refrigerators05.webp";
import refrigeratorTypeImage06 from "@/assets/images/static/categoryType/Refrigerators/refrigerators06.webp";
import refrigeratorTypeImage07 from "@/assets/images/static/categoryType/Refrigerators/refrigerators07.webp";

import dishwashersBannerImage from "@/assets/images/static/categoryType/Dishwashers/HeroBanner.webp";
import dishwashersTypeImage01 from "@/assets/images/static/categoryType/Dishwashers/FullConsoleDishwashers.webp";
import dishwashersTypeImage02 from "@/assets/images/static/categoryType/Dishwashers/FullyIntegratedDishwashers.webp";
import dishwashersTypeImage03 from "@/assets/images/static/categoryType/Dishwashers/PanelReadyDishwashers.webp";
import dishwashersTypeImage04 from "@/assets/images/static/categoryType/Dishwashers/DishwasherDrawers.webp";
import dishwashersTypeImage05 from "@/assets/images/static/categoryType/Dishwashers/PortableDishwashers.webp";

import freezerBannerImage from "@/assets/images/static/categoryType/Freezer/HeroBanner.webp";
import freezerTypeImage01 from "@/assets/images/static/categoryType/Freezer/UprightFreezers.webp";
import freezerTypeImage02 from "@/assets/images/static/categoryType/Freezer/ChestFreezers.webp";
import freezerTypeImage03 from "@/assets/images/static/categoryType/Freezer/UndercounterFreezers.webp";
import freezerTypeImage04 from "@/assets/images/static/categoryType/Freezer/FreezerDrawers.webp";
import freezerTypeImage05 from "@/assets/images/static/categoryType/Freezer/IceMakers.webp";

import rangeBannerImage from "@/assets/images/static/categoryType/Ranges/HeroBanner.webp";
import rangeTypeImage01 from "@/assets/images/static/categoryType/Ranges/GasRanges.webp";
import rangeTypeImage02 from "@/assets/images/static/categoryType/Ranges/ElectricRanges.webp";
import rangeTypeImage03 from "@/assets/images/static/categoryType/Ranges/DualFuelRanges.webp";
import rangeTypeImage04 from "@/assets/images/static/categoryType/Ranges/InductionRanges.webp";

import cookingBannerImage from "@/assets/images/static/categoryType/Cooking/HeroBanner.png";
import ranges from "@/assets/images/static/categoryType/Cooking/ranges.webp";
import cooktops from "@/assets/images/static/categoryType/Cooking/cooktops.webp";
import wallOvens from "@/assets/images/static/categoryType/Cooking/wallOvens.webp";
import microwaves from "@/assets/images/static/categoryType/Cooking/microwaves.webp";
import rangeHoods from "@/assets/images/static/categoryType/Cooking/rangeHoods.webp";
import coffeeSystems from "@/assets/images/static/categoryType/Cooking/coffeeSystems.webp";
import trashCompactors from "@/assets/images/static/categoryType/Cooking/trashCompactors.webp";
import foodDisposals from "@/assets/images/static/categoryType/Cooking/foodDisposals.webp";
import outdoorGrills from "@/assets/images/static/categoryType/Cooking/outdoorGrills.webp";
import kitchenettes from "@/assets/images/static/categoryType/Cooking/kitchenettes.webp";

import wallOvensBannerImage from "@/assets/images/static/categoryType/WallOvens/HeroBanner.webp";
import wallOvensTypeImage01 from "@/assets/images/static/categoryType/WallOvens/SingleWallOvens.webp";
import wallOvensTypeImage02 from "@/assets/images/static/categoryType/WallOvens/DoubleWallOvens.webp";
import wallOvensTypeImage03 from "@/assets/images/static/categoryType/WallOvens/MicrowaveOvenCombos.webp";
import wallOvensTypeImage04 from "@/assets/images/static/categoryType/WallOvens/WarmingDrawers.png";

import microwavesBannerImage from "@/assets/images/static/categoryType/MicrowavesOTR/MicrowavesBanner.webp";
import microwavesTypeImage01 from "@/assets/images/static/categoryType/MicrowavesOTR/CountertopMicrowave.png";
import microwavesTypeImage02 from "@/assets/images/static/categoryType/MicrowavesOTR/OverTheRangeMicrowave.png";
import microwavesTypeImage03 from "@/assets/images/static/categoryType/MicrowavesOTR/MicrowaveDrawers.png";

import rangeHoodsBannerImage from "@/assets/images/static/categoryType/RangeHoods/HeroBanner.webp";
import rangeHoodsTypeImage01 from "@/assets/images/static/categoryType/RangeHoods/InsertRangeHood.png";
import rangeHoodsTypeImage02 from "@/assets/images/static/categoryType/RangeHoods/WallMountedRangeHood.png";
import rangeHoodsTypeImage03 from "@/assets/images/static/categoryType/RangeHoods/IslandRangeHood.png";
import rangeHoodsTypeImage04 from "@/assets/images/static/categoryType/RangeHoods/UnderCabinetRangeHood.png";
import rangeHoodsTypeImage05 from "@/assets/images/static/categoryType/RangeHoods/DowndraftRangeHood.png";

import cooktopsBannerImage from "@/assets/images/static/categoryType/Cooktops/HeroBanner.webp";
import cooktopsTypeImage01 from "@/assets/images/static/categoryType/Cooktops/GasCooktops.webp";
import cooktopsTypeImage02 from "@/assets/images/static/categoryType/Cooktops/ElectricCooktops.webp";
import cooktopsTypeImage03 from "@/assets/images/static/categoryType/Cooktops/InductionCooktops.webp";
import cooktopsTypeImage04 from "@/assets/images/static/categoryType/Cooktops/Rangetops.webp";

import compactorsDisposalBannerImage from "@/assets/images/static/categoryType/CompactorsDisposal/HeroBanner.webp";
import compactorsDisposalTypeImage01 from "@/assets/images/static/categoryType/CompactorsDisposal/TrashCompactors.png";
import compactorsDisposalTypeImage02 from "@/assets/images/static/categoryType/CompactorsDisposal/FoodDisposals.png";

import grillsOutdoorKitchensBannerImage from "@/assets/images/static/categoryType/GrillsOutdoorKitchens/HeroBanner.webp";
import grillsOutdoorKitchensTypeImage01 from "@/assets/images/static/categoryType/GrillsOutdoorKitchens/OutdoorGrills.webp";

import laundryBannerImage from "@/assets/images/static/categoryType/Laundry/HeroBanner.webp";
import washerAndDryerTypeImage01 from "@/assets/images/static/categoryType/Laundry/WasherAndDryer/WasherDryerSets.webp";
import washerAndDryerTypeImage02 from "@/assets/images/static/categoryType/Laundry/WasherAndDryer/LaundryCenters.webp";
import washerAndDryerTypeImage03 from "@/assets/images/static/categoryType/Laundry/WasherAndDryer/WasherDryerCombos.webp";
import washerAndDryerTypeImage04 from "@/assets/images/static/categoryType/Laundry/WasherAndDryer/WasherDryerPedestals.webp";

import washersTypeImage01 from "@/assets/images/static/categoryType/Laundry/Washers/FrontLoadWashers.webp";
import washersTypeImage02 from "@/assets/images/static/categoryType/Laundry/Washers/TopLoadWashers.webp";
import washersTypeImage03 from "@/assets/images/static/categoryType/Laundry/Washers/CommercialWashers.webp";

import dryerTypeImage01 from "@/assets/images/static/categoryType/Laundry/Dryers/GasDryers.webp";
import dryerTypeImage02 from "@/assets/images/static/categoryType/Laundry/Dryers/ElectricDryers.webp";
import dryerTypeImage03 from "@/assets/images/static/categoryType/Laundry/Dryers/CommercialDryers.webp";

import LuxuryRefrigeratorBrands05 from "@/assets/images/static/categoryType/LuxuryRefrigeratorBrands/LuxuryRefrigeratorBrands05.webp"
import LuxuryRefrigeratorBrands04 from "@/assets/images/static/categoryType/LuxuryRefrigeratorBrands/LuxuryRefrigeratorBrands04.webp"
import LuxuryRefrigeratorBrands03 from "@/assets/images/static/categoryType/LuxuryRefrigeratorBrands/LuxuryRefrigeratorBrands03.webp"
import LuxuryRefrigeratorBrands02 from "@/assets/images/static/categoryType/LuxuryRefrigeratorBrands/LuxuryRefrigeratorBrands02.webp"
import LuxuryRefrigeratorBrands01 from "@/assets/images/static/categoryType/LuxuryRefrigeratorBrands/LuxuryRefrigeratorBrands01.webp"

import ThorKitchenCategory_1 from "@/assets/images/static/brands/Thor_Kitchen/ThorKitchen_Ranges_1.webp";


export const allCategoryList = [ 
  { 
    Categories: {
      id: 0,
      title: "Categories",
      slug: "",
      shopAll: "",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Refrigerators",
        bannerImg: RefrigeratorBannerImage,
      },
      brandOptions: [             
        { 
          img: refrigeratorTypeImage02,
          title:'All Refrigerators', 
          slug: '/refrigerators-freezers',
        },
          
        { 
          img: refrigeratorTypeImage03,
          title:'Freezers', 
          slug: '/freezer-ice-makers',
        },
        { 
          img: refrigeratorTypeImage04,
          title:'Ice Makers', 
          slug: '/freezer-ice-makers',
        },
        { 
          img: ThorKitchenCategory_1,
          title:'Ranges',
          slug: '/all-ranges',
        }, 
        { 
          img: refrigeratorTypeImage06,
          title:'Cooktops', 
          slug: '/all-cooktops',
        },
        { 
          img: refrigeratorTypeImage07,
          title:'Well Ovens', 
          slug: '/all-wall-ovens',
        },
        { 
          img: refrigeratorTypeImage07,
          title:'Microwaves', 
          slug: '/all-microwaves-otr',
        },
        { 
          img: refrigeratorTypeImage07,
          title:'RangeHoods', 
          slug: '/all-rangeHoods',
        },
        { 
          img: refrigeratorTypeImage07,
          title:'CompactorsDisposal', 
          slug: '/all-compactors-disposal',
        },
        { 
          img: refrigeratorTypeImage07,
          title:'GrillsOutdoorKitchens', 
          slug: '/all-grillsOutdoor-kitchens',
        }
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    RefrigeratorsFreezers: {
      id: 0,
      title: "Refrigerators & Freezers",
      slug: "/refrigerators/all-refrigerators",
      shopAll: "/refrigerators/all-refrigerators",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Refrigerators",
        bannerImg: RefrigeratorBannerImage,
      },
      brandOptions: [
        { 
          img: refrigeratorTypeImage01,
          title:'Refrigerators',
          slug: '/refrigerators',
         },       
        { 
          img: refrigeratorTypeImage02,
          title:'Freezers', 
          slug: '/freezers',
        },
          
        { 
          img: refrigeratorTypeImage03,
          title:'Ice Makers', 
          slug: '/ice-makers',
        },
        { 
          img: refrigeratorTypeImage04,
          title:'Wine Coolers', 
          slug: '/wine-coolers',
        },
        { 
          img: refrigeratorTypeImage05,
          title:'Beer Coolers & Kegerators', 
          slug: '/beer-coolers-&-kegerators',
        },
        { 
          img: refrigeratorTypeImage06,
          title:'Beverage Centers', 
          slug: '/beverage-centers',
        },
        { 
          img: refrigeratorTypeImage07,
          title:'Smart Refrigerators', 
          slug: '/smart-appliances/smart-refrigeration',
        }
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllDishwashers: {
      id: 1,
      title: "Dishwashers",
      slug: "/dishwashers",
      shopAll: "/dishwashers",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Dishwashers",
        bannerImg: dishwashersBannerImage,
      },
      brandOptions: [
        { 
          img: dishwashersTypeImage01,
          title:'Front Control Dishwashers',
          slug: '/built-in-dishwashers/front-control-dishwashers?fieldIds=162&fieldValueIds=36902',
          imageFlag: true,
         },       
        { 
          img: dishwashersTypeImage02,
          title:'Top Control Dishwashers',
          slug: '/built-in-dishwashers/top-control-dishwashers?fieldIds=162&fieldValueIds=36904', 
          imageFlag: true,
        },
          
        { 
          img: dishwashersTypeImage03,
          title:'Panel Ready Dishwashers', 
          slug: '/built-in-dishwashers/panel-ready-dishwashers?fieldIds=139&fieldValueIds=2733',
          imageFlag: true,
        },
        { 
          img: dishwashersTypeImage04,
          title:'Dishwasher Drawers', 
          slug: '/dishwashers/dishwasher-drawers',
          imageFlag: true,
        },
        { 
          img: dishwashersTypeImage05,
          title:'Portable Dishwashers', 
          slug: '/dishwashers/portable-dishwashers',
          imageFlag: true,
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllCooking: {
      id: 4,
      title: "Cooking",
      slug: "/cooking",
      shopAll: "/cooking",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Cooking Appliances",
        bannerImg: cookingBannerImage,
      },
      brandOptions: [
        { 
          img: ranges,
          title:'Ranges',
          slug: '/ranges/all-ranges',
          imageFlag: true,
          bgGray:true
         },       
        { 
          img: cooktops,
          title:'Cooktops', 
          slug: '/cooktops/all-cooktops',
          imageFlag: true,
          bgGray:true
        },          
        { 
          img: wallOvens,
          title:'Wall Ovens', 
          slug: '/wall-ovens/all-wall-ovens',
          imageFlag: true,
          bgGray:true
        },
        { 
          img: microwaves,
          title:'Microwaves', 
          slug: '/microwaves-otr/all-microwaves',
          imageFlag: true,
          bgGray:true
        },
        { 
          img: rangeHoods,
          title:'Range Hoods', 
          slug: '/range-hoods/all-range-hoods',
          imageFlag: true,
          bgGray:true
        },
        { 
          img: coffeeSystems,
          title:'Coffee Systems', 
          slug: '/coffee-systems',
          imageFlag: true,
          bgGray:true
        },
        { 
          img: trashCompactors,
          title:'Trash Compactors', 
          slug: '/trash-compactors',
          // slug: '/compactors-disposal/all-compactors-disposal',
          imageFlag: true,
          bgGray:true
        },
        { 
          img: foodDisposals,
          title:'Food Disposals', 
          slug: '/food-disposal',
          imageFlag: true,
          bgGray:true
        },
        { 
          img: outdoorGrills,
          title:'Outdoor Grills', 
          slug: '/grills-outdoor-kitchens/all-grills-outdoor-kitchens',
          imageFlag: true,
          bgGray:true
        },
        { 
          img: kitchenettes,
          title:'Kitchenettes', 
          slug: '/kitchenettes',
          imageFlag: true,
          bgGray:true
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllLaundry: {
      id: 10,
      title: "Laundry",
      slug: "/laundry",
      shopAll: "/laundry",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Laundry",
        bannerImg: laundryBannerImage,
      },
      brandOptions: [
        { 
          img: washerAndDryerTypeImage01,
          title:'Washer & Dryer Sets',
          slug: '/laundry/washer-dryer-sets',
          type: "WasherDryer"
         },     
         { 
          img: washerAndDryerTypeImage02,
          title:'Laundry Centers',
          slug: '/laundry/stacked-washer-dryer-sets',
          type: "WasherDryer"
         },  
         { 
          img: washerAndDryerTypeImage03,
          title:'Washer Dryer Combos',
          slug: '/laundry/washer-dryer-combo-units',
          type: "WasherDryer"
         },  
         { 
          img: washerAndDryerTypeImage04,
          title:'Washer & Dryer Pedestals',
          slug: '/laundry/washer-dryer-pedestals',
          type: "WasherDryer"
         },    
         
         { 
          img: washersTypeImage01,
          title:'Front Load Washers',
          slug: '/washers/front-load-washers?fieldIds=140&fieldValueIds=27145',
          type: "Washers",
          bgGray:true
         },     
         { 
          img: washersTypeImage02,
          title:'Top Load Washers',
          slug: '/washers/top-load-washers?fieldIds=140&fieldValueIds=27144',
          type: "Washers",
          bgGray:true

         },  
         { 
          img: washersTypeImage03,
          title:'Commercial Washers',
          slug: '/laundry/commercial-washers',
          type: "Washers",
          bgGray:true

         },  
         
         { 
          img: dryerTypeImage01,
          title:'Gas Dryers',
          slug: '/dryers/gas-dryers',
          type: "Dryers",
          bgGray:true

         },   
         { 
          img: dryerTypeImage02,
          title:'Electric Dryers',
          slug: '/dryers/electric-dryers',
          type: "Dryers",
          bgGray:true

         }, 
         { 
          img: dryerTypeImage03,
          title:'Commercial Dryers',
          slug: '/laundry/commercial-dryers',
          type: "Dryers",
          bgGray:true
         },  
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    FreezersIceMakers: {
      id: 2,
      title: "Freezers & Ice Makers",
      slug: "/freezers",
      shopAll: "/freezers",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Freezer and Ice Makers",
        bannerImg: freezerBannerImage,
      },
      brandOptions: [
        { 
          img: freezerTypeImage01,
          title:'Upright Freezers',
          slug: '/freezers/upright-freezers',
         },       
        { 
          img: freezerTypeImage02,
          title:'Chest Freezers', 
          slug: '/freezers/chest-freezers',
          imageFlag: true,
        },
          
        { 
          img: freezerTypeImage03,
          title:'Undercounter Freezers', 
          slug: '/freezers/undercounter-freezers',
        },
        { 
          img: freezerTypeImage04,
          title:'Freezer Drawers', 
          slug: '/freezers/freezer-drawers',
        },
        { 
          img: freezerTypeImage05,
          title:'Ice Makers', 
          slug: '/ice-makers',
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    IceMakers: {
      id: 2,
      title: "Freezers & Ice Makers 1",
      slug: "/freezers",
      shopAll: "/freezers",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Freezer ice makers",
        bannerImg: freezerBannerImage,
      },
      brandOptions: [
        { 
          img: freezerTypeImage01,
          title:'Upright Freezers',
          slug: '/freezers/upright-freezers',
         },       
        { 
          img: freezerTypeImage02,
          title:'Chest Freezers', 
          slug: '/freezers/chest-freezers',
          imageFlag: true,
        },
          
        { 
          img: freezerTypeImage03,
          title:'Undercounter Freezers', 
          slug: '/freezers/undercounter-freezers',
        },
        { 
          img: freezerTypeImage04,
          title:'Freezer Drawers', 
          slug: '/freezers/freezer-drawers',
        },
        { 
          img: freezerTypeImage05,
          title:'Ice Makers', 
          slug: '/ice-makers',
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllRanges: {
      id: 3,
      title: "Ranges",
      slug: "/ranges",
      shopAll: "/ranges",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Ranges",
        bannerImg: rangeBannerImage,
      },
      brandOptions: [
        { 
          img: rangeTypeImage01,
          title:'Gas Ranges',
          slug: '/ranges/gas-ranges',
          imageFlag: true,
         },       
        { 
          img: rangeTypeImage02,
          title:'Electric Ranges', 
          slug: '/ranges/electric-ranges',
          imageFlag: true,
        },
          
        { 
          img: rangeTypeImage03,
          title:'Dual Fuel Ranges', 
          slug: '/ranges/dual-fuel-ranges',
          imageFlag: true,
        },
        { 
          img: rangeTypeImage04,
          title:'Induction Ranges', 
          slug: '/ranges/induction-ranges',
          imageFlag: true,
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllCooktops: {
      id: 4,
      title: "Cooktops",
      slug: "/cooktops",
      shopAll: "/cooktops",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Cooktops",
        bannerImg: cooktopsBannerImage,
      },
      brandOptions: [
        { 
          img: cooktopsTypeImage01,
          title:'Gas Cooktops',
          slug: '/cooktops/gas-cooktops',
          imageFlag: true
         },       
        { 
          img: cooktopsTypeImage02,
          title:'Electric Cooktops', 
          slug: '/cooktops/electric-cooktops',
          imageFlag: true
        },          
        { 
          img: cooktopsTypeImage03,
          title:'Induction Cooktops', 
          slug: '/cooktops/induction-cooktops',
          imageFlag: true
        },
        { 
          img: cooktopsTypeImage04,
          title:'Rangetops', 
          slug: 'cooktops/rangetops?fieldIds=38&fieldValueIds=22661',
          imageFlag: true
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllWallOvens: {
      id: 5,
      title: "Wall Ovens",
      slug: "/wall-ovens",
      shopAll: "/wall-ovens",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Wall Ovens",
        bannerImg: wallOvensBannerImage,
      },
      brandOptions: [
        { 
          img: wallOvensTypeImage01,
          title:'Single Wall Ovens',
          slug: '/wall-ovens/single-wall-ovens',
          imageFlag: true
        },       
        { 
          img: wallOvensTypeImage02,
          title:'Double Wall Ovens', 
          slug: '/wall-ovens/double-wall-ovens',
          imageFlag: true
        }, 
        { 
          img: wallOvensTypeImage03,
          title:'Microwave + Oven Combos',
          slug: '/wall-ovens/microwave-combination-ovens',
          imageFlag: true 
        },
        { 
          img: wallOvensTypeImage04,
          title:'Warming Drawers', 
          slug: '/wall-ovens/warming-drawers',
          fullImage: true
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllMicrowavesOtr: {
      id: 6,
      title: "Microwaves",
      slug: "/microwaves-otr",
      shopAll: "/microwaves-otr",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Microwaves",
        bannerImg: microwavesBannerImage,
      },
      brandOptions: [
        { 
          img: microwavesTypeImage01,
          title:'Countertop Microwaves',
          slug: '/microwaves-otr/countertop-microwaves',
          fullImage: true
         },       
        { 
          img: microwavesTypeImage02,
          title:'Over the Range Microwaves', 
          slug: '/microwaves-otr/over-the-range-microwave',
          fullImage: true
        },          
        { 
          img: microwavesTypeImage03,
          title:'Microwave Drawers', 
          slug: '/microwaves-otr/microwave-drawers',
          fullImage: true
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllRangeHoods: {
      id: 7,
      title: "Range Hoods",
      slug: "/range-hoods",
      shopAll: "/range-hoods",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Range Hoods",
        bannerImg: rangeHoodsBannerImage,
      },
      brandOptions: [
        { 
          img: rangeHoodsTypeImage01,
          title:'Insert Range Hoods',
          slug: '/range-hoods/insert-range-hoods',
          fullImage: true
         },       
        { 
          img: rangeHoodsTypeImage02,
          title:'Wall Mounted Range Hoods', 
          slug: '/range-hoods/wall-mounted-range-hoods',
          fullImage: true
        },          
        { 
          img: rangeHoodsTypeImage03,
          title:'Island Range Hoods', 
          slug: '/range-hoods/island-range-hoods',
          fullImage: true
        },
        { 
          img: rangeHoodsTypeImage04,
          title:'Under-Cabinet Range Hood', 
          slug: '/range-hoods/under-cabinet-range-hoods',
          fullImage: true
        },
        { 
          img: rangeHoodsTypeImage05,
          title:'Downdraft Range Hoods', 
          slug: '/range-hoods/downdraft-range-hoods',
          fullImage: true
        },
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },
    AllCompactorsDisposal: {
      id: 8,
      title: "Compactors & Disposal ",
      slug: "/trash-compactors",
      shopAll: "/trash-compactors",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Compactors Disposal",
        bannerImg: compactorsDisposalBannerImage,
      },
      brandOptions: [
        { 
          img: compactorsDisposalTypeImage01,
          title:'Trash Compactors',
          slug: '/trash-compactors',
          fullImage: true
         },       
        { 
          img: compactorsDisposalTypeImage02,
          title:'Food Disposals', 
          slug: '/food-disposal',
          fullImage: true
        },          
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    }, 
    AllGrillsOutdoorKitchens: {
      id: 9,
      title: "Grills Outdoor Kitchens",
      slug: "/grills-outdoor-kitchens",
      shopAll: "/grills-outdoor-kitchens",
      BannerData: {
        subheading: "Up to 45% OFF",
        descriptionTxt: "Select In-Stock Grills Outdoor Kitchens",
        bannerImg: grillsOutdoorKitchensBannerImage,
      },
      brandOptions: [
        { 
          img: grillsOutdoorKitchensTypeImage01,
          title:'Outdoor Grills',
          slug: '/grills-outdoor-kitchens',
          fullImage: true
         },         
      ],
      collectionList: [
        {
          title:"Thermador",
          img:LuxuryRefrigeratorBrands01,
          link: "/thermador",
        },
        {
          title:"Monogram",
          img:LuxuryRefrigeratorBrands02,
          link: "/monogram",
        },
        {
          title:"Signature Kitchen Suite",
          img:LuxuryRefrigeratorBrands03,
          link: "/signature-kitchen-suite",
        },
        {
          title:"Fisher & Paykel",
          img:LuxuryRefrigeratorBrands04,
          link: "/fisher-paykel",
        },
        {
          title:"Miele",
          img:LuxuryRefrigeratorBrands05,
          link: "/miele",
        },
      ],
      contentList:[]
    },    
  }, 
];